import { Auth, getAuth } from 'firebase/auth';
import i18next from 'i18next';

const supportedLanguages = ['de', 'fr', 'it'];
const fallbackLanguage = 'de';

function getFirebaseAuthLanguage(language?: string) {
  const activeLanguage = (
    language
    ?? i18next.resolvedLanguage
    ?? i18next.language
    ?? fallbackLanguage
  ).toLowerCase();
  const matchedLanguage = supportedLanguages.find((supportedLanguage) => (
    activeLanguage.startsWith(supportedLanguage)
  ));

  return matchedLanguage ?? fallbackLanguage;
}

export default function syncAuthLanguage(auth?: Auth, language?: string) {
  const firebaseAuth = auth ?? getAuth();
  const nextLanguageCode = getFirebaseAuthLanguage(language);

  firebaseAuth.languageCode = nextLanguageCode;

  return firebaseAuth;
}
